import { configureStore } from '@reduxjs/toolkit';
import languageReducer from './slices/languageSlice';
import uiReducer from './slices/uiSlice';

const store = configureStore({
  reducer: {
    language: languageReducer,
    ui: uiReducer,
  },
});

export default store; 